import React from 'react'
import styled from 'styled-components'

const KeyboardButton = styled.div`
    display: inline-block;
    padding: 3px 5px;
    font: 16px "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
    /* line-height: 53px; */
    vertical-align: middle;
    background-color: #fafbfc;
    border: solid 2px #d1d5da;
    border-bottom-color: #c6cbd1;
    border-radius: 3px;
    margin-bottom: 4px;
    -webkit-box-shadow: inset 0 -3px 0 #c6cbd1;
    box-shadow: inset 0 -2px 0 #c6cbd1;
`

export default KeyboardButton



// WEBPACK FOOTER //
// ./src/components/KeyboardButton.js